/**
 * ClassParkingDayPartRebalancedTimeline — таймлайн слоя «Классифицированные
 * парковки (ребаланс, по времени суток)» (DA-14953).
 *
 * Заменяет собой сайдбарную радио-группу «Время суток». Курсор на рельсе
 * выбирает часть дня (5 неравных интервалов, значения 1–5, см.
 * CLASS_DAY_PART_STYLE.parts / пресет DAY_PART_CLASS_DOMAIN). Значение пишется в
 * redux (mapFilters.classifiedParkingDayPartRebalancedStatuses); перезапрос
 * тайлов на смену части дня — в Map.setParkingClassDayPartRebalancedFilters.
 *
 * Даты/степпера нет: слой агрегирует ребаланс за 14 дней, выбор — только часть суток.
 * Монтируется только когда слой активен (withDisplayedLayersCheck).
 */
import React from 'react';
import { connect } from 'react-redux';
import { t } from '@lingui/macro';
import { onChangeMapFilters } from '../../ac/onChangeMapFilters';
import { withDisplayedLayersCheck } from '../../HOC/withDisplayedLayersCheck';
import { MapTimeline } from './MapTimeline';
import { DAY_PART_CLASS_DOMAIN, dayPartClassBands } from './presets';

const ClassParkingDayPartRebalancedTimelineComponent = ({
    classifiedParkingDayPartRebalancedStatuses,
    setDayPart,
}) => (
    <MapTimeline
        domain={DAY_PART_CLASS_DOMAIN}
        cursor={classifiedParkingDayPartRebalancedStatuses ?? 1}
        onCursorChange={value => {
            if (value !== classifiedParkingDayPartRebalancedStatuses) setDayPart(value);
        }}
        minorTicks
        topBands={dayPartClassBands()}
    />
);
const mapStateToProps = ({ mapFilters: { classifiedParkingDayPartRebalancedStatuses } }) => ({
    classifiedParkingDayPartRebalancedStatuses,
});
const mapDispatchToProps = dispatch => ({
    setDayPart: value => dispatch(onChangeMapFilters('classifiedParkingDayPartRebalancedStatuses', value)),
});
const ConnectedComponent = connect(
    mapStateToProps,
    mapDispatchToProps
)(ClassParkingDayPartRebalancedTimelineComponent);

export const ClassParkingDayPartRebalancedTimeline = withDisplayedLayersCheck(
    ConnectedComponent,
    `${t`Классифицированные парковки`} (${t`ребаланс, по времени суток`})`
);
